import { formatDateAsString } from '@verantos-dev/shared-utils';

const EM_DASH = '—';

// Renders the inherited cohort study-period date. The value may be a date-only
// `YYYY-MM-DD` or a full ISO datetime (after the cohort inline edit's
// `toISOString()`); the shared `formatDateAsString` handles both (dayjs.utc →
// MM/DD/YYYY). Only the missing-value em-dash is AD-specific.
export const formatIsoDate = (iso: string | null | undefined): string => {
  if (!iso) return EM_DASH;
  return formatDateAsString(iso);
};
